<section class="card">
  <div class="flex justify-between">
    <h2>Agregar Plan</h2>
    <app-back-button ></app-back-button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-4 max-w-m w-md space-y-4">
    <div class="grid grid-cols-12">
      <div class="pb-4 pr-4 col-span-4">
        <label for="shopSubscriptionName" class="block mb-1 font-semibold">Nombre del Plan</label>
        <input id="shopSubscriptionName" type="text" pInputText formControlName="shopSubscriptionName" class="w-full" />
        <p-message *ngIf="form.get('shopSubscriptionName')?.touched && form.get('shopSubscriptionName')?.invalid"  severity="error" size="small" variant="simple">El nombre es obligatorio y debe tener máximo 100 caracteres.</p-message>
      </div>
      <div class="pb-4 pr-4 col-start-6 col-span-2">
        <label for="shopMaxUsers" class="block mb-1 font-semibold">Máximo Usuarios</label>
        <input id="shopMaxUsers" type="number" pInputText formControlName="shopMaxUsers" min="0" step="1" class="w-full" />
        <p-message *ngIf="form.get('shopMaxUsers')?.touched && form.get('shopMaxUsers')?.invalid"  severity="error" size="small" variant="simple">Debe ser un número entero mayor o igual a 0.</p-message>
      </div>
      <div class="pb-4 pr-4 col-start-10 col-span-2">
        <label for="shopMaxProducts" class="block mb-1 font-semibold">Máximo Productos</label>
        <input id="shopMaxProducts" type="number" pInputText formControlName="shopMaxProducts" min="0" step="1" class="w-full" />
        <p-message *ngIf="form.get('shopMaxProducts')?.touched && form.get('shopMaxProducts')?.invalid"  severity="error" size="small" variant="simple">Debe ser un número entero mayor o igual a 0.</p-message>
      </div>
    </div>

    <div class="grid grid-cols-12">
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch formControlName="shopPosAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Acceso POS</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch formControlName="shopAnaliticsAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Acceso Analíticas</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch formControlName="shopInfobipIntegrationAllow" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Acceso ChatApp</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">  
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch formControlName="shopValidateClientAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Validación Clientes</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch formControlName="shopCalendarAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Agenda Timekit</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch formControlName="shopCashRegisterAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Acceso Cajas</span>
        </label>
      </div>
    </div>
    <hr>
    <div class="grid grid-cols-12">
      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Tipos de Producto Permitidos</label>
        <div *ngFor="let option of productTypeOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="option.value" 
            name="shopProductTypesAllow" 
            [binary]="true"
            (onChange)="onPTCheckboxChange($event, option.value)"
            size="large">
          </p-checkbox>
          <label [for]="option.value">{{ option.label }}</label>
        </div>
        <p-message *ngIf="form.get('shopProductTypesAllow')?.touched && form.get('shopProductTypesAllow')?.invalid"  severity="error" size="small" variant="simple">Debes seleccionar al menos un tipo de producto.</p-message>
      </div>

      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Planes</label>
        <div *ngFor="let option of planOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="option.name"
            [binary]="true"
            (onChange)="onPlanCheckboxChange($event, option)"
            size="large">
          </p-checkbox>
          <label [for]="option.name">{{ option.label }}</label>
        </div>
      </div>

      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Imports / Exports</label>
        <div *ngFor="let option of importExportOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="option.name" 
            [binary]="true"
            (onChange)="onIECheckboxChange($event, option)"
            size="large">
          </p-checkbox>
          <label [for]="option.name">{{ option.label }}</label>
        </div>
      </div>

      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Logs</label>
        <div *ngFor="let option of logOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="option.name" 
            [binary]="true"
            (onChange)="onLogsCheckboxChange($event, option)"
            size="large">
          </p-checkbox>
          <label [for]="option.name">{{ option.label }}</label>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <p-button severity="success" [disabled]="form.invalid" [loading]="loading" variant="outlined" rounded (click)="onSubmit()">
        Guardar
      </p-button>
    </div>
  </form>
  <p-toast></p-toast>
</section>